<template>
  <div class="wrapper">
    <parallax
      class="section page-header services-header header-filter"
      :style="headerStyle"
    >
      <div class="overlay"></div>
      <div class="container">
        <div class="md-layout">
          <div
            class="md-layout-item md-size-70 md-small-size-70 md-xsmall-size-100"
          >
            <h1 class="title">Conócenos</h1>
            <div class="md-layout md-gutter list-container ">
              <div
                class="md-layout-item md-medium-size-50 md-small-size-100 md-xsmall-size-100"
              >
                <h4>Misión</h4>
                <hr />
                <p>
                  Proporcionar a nuestros clientes servicios con calidad en
                  obras de ingeniería, cumpliendo con la normatividad
                  establecida. Sustentándose en tecnologías actualizadas y de
                  bajo costo, que permiten garantizar calidad y eficiencia en el
                  desarrollo de nuestros proyectos para dar cumplimiento y
                  garantía en la labor que se nos confía.
                </p>
              </div>

              <div
                class="md-layout-item image-text md-medium-size-50 md-small-size-100 md-xsmall-size-100"
              >
                <h4>Visión</h4>
                <hr />
                <p>
                  Proporcionar a nuestros clientes servicios con calidad en
                  obras de ingeniería, cumpliendo con la normatividad
                  establecida. Sustentándose en tecnologías actualizadas y de
                  bajo costo, que permiten garantizar calidad y eficiencia en el
                  desarrollo de nuestros proyectos para dar cumplimiento y
                  garantía en la labor que se nos confía.
                </p>
              </div>
            </div>
            <br />
            <md-button to="/contactanos" class=" md-lg">CONTÁCTANOS</md-button>
          </div>
        </div>
      </div>
    </parallax>
    <div class="main main-raised">
      <div class="section text-center">
        <div class="container">
          <h2 class="title">Nuestros Ingenieros</h2>
          <div class="team">
            <div class="md-layout">
              <div class="md-layout-item md-medium-size-50 md-small-size-100">
                <div class="team-player">
                  <md-card class="md-card-plain">
                    <!--<div class="md-layout-item md-size-50 mx-auto">
                      <img
                        :src="teamImg1"
                        alt="Thumbnail Image"
                        class="img-raised rounded-circle img-fluid"
                      />
                    </div>-->
                    <h4 class="card-title">
                      David Reinozo Giraldo
                      <hr />
                      <small class="card-description text-muted"
                        >Gerente General</small
                      >
                    </h4>

                    <md-card-content>
                      <p class="card-description">
                        <a href="tel:+573183821276">Cel. 3183821276</a> <br />
                        <a href="mailto:david.r@iscsas.com"
                          >david.r@iscsas.com</a
                        >
                      </p>
                    </md-card-content>

                    <md-card-actions class="text-center">
                      <md-button
                        href="tel:+573175160987"
                        class="md-just-icon md-simple"
                      >
                        <i class="fas fa-phone"></i>
                      </md-button>
                      <md-button
                        href="mailto:david.r@iscsas.com"
                        class="md-just-icon md-simple"
                        target="_blank"
                      >
                        <i class="fas fa-envelope"></i>
                      </md-button>
                      <md-button
                        href="https://wa.me/573183821276"
                        class="md-just-icon md-simple"
                        target="_blank"
                      >
                        <i class="fab fa-whatsapp"></i>
                      </md-button>
                    </md-card-actions>
                  </md-card>
                </div>
              </div>
              <div class="md-layout-item md-medium-size-50 md-small-size-100">
                <div class="team-player">
                  <md-card class="md-card-plain">
                    <!--<div class="md-layout-item md-size-50 mx-auto">
                      <img
                        :src="teamImg1"
                        alt="Thumbnail Image"
                        class="img-raised rounded-circle img-fluid"
                      />
                    </div>-->
                    <h4 class="card-title">
                      David Lozano Salazar
                      <hr />
                      <small class="card-description text-muted"
                        >Gerente Técnico
                      </small>
                    </h4>

                    <md-card-content>
                      <p class="card-description">
                        <a href="tel:+573175160987">Cel: 3175160987</a>
                        <br />
                        <a href="mailto:david.r@iscsas.com"
                          >david.l@iscsas.com</a
                        >
                      </p>
                    </md-card-content>

                    <md-card-actions class="text-center">
                      <md-button
                        href="tel:+573183821276"
                        class="md-just-icon md-simple"
                      >
                        <i class="fas fa-phone"></i>
                      </md-button>
                      <md-button
                        href="mailto:david.l@iscsas.com"
                        class="md-just-icon md-simple"
                        target="_blank"
                      >
                        <i class="fas fa-envelope"></i>
                      </md-button>
                      <md-button
                        href="https://wa.me/573175160987"
                        class="md-just-icon md-simple"
                        target="_blank"
                      >
                        <i class="fab fa-whatsapp"></i>
                      </md-button>
                    </md-card-actions>
                  </md-card>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="section section-contacts">
        <div class="container">
          <div class="md-layout">
            <div class="md-layout-item md-size-66 md-xsmall-size-100 mx-auto">
              <h2 class="text-center title">Déjanos asesorarte</h2>
              <h4 class="text-center description">
                Describe detalles sobre tu proyecto o necesidad, responderemos
                en un par de horas.
              </h4>
              <form class="contact-form" @submit.prevent="sendEmail">
                <div class="md-layout">
                  <div class="md-layout-item md-size-50">
                    <md-field>
                      <label>Nombre</label>
                      <md-input v-model="name" type="text"></md-input>
                    </md-field>
                  </div>
                  <div class="md-layout-item md-size-50">
                    <md-field>
                      <label>Correo</label>
                      <md-input v-model="email" type="email"></md-input>
                    </md-field>
                  </div>
                  <div class="md-layout-item md-size-50">
                    <md-field>
                      <label>Ciudad</label>
                      <md-input v-model="ciudad" type="text"></md-input>
                    </md-field>
                  </div>
                  <div class="md-layout-item md-size-50">
                    <md-field>
                      <label>Teléfono</label>
                      <md-input v-model="telefono" type="tel"></md-input>
                    </md-field>
                  </div>
                </div>
                <md-field maxlength="5">
                  <label>Mensaje</label>
                  <md-textarea v-model="message"></md-textarea>
                </md-field>
                <div class="md-layout">
                  <div class="md-layout-item md-size-33 mx-auto text-center">
                    <md-button type="submit" class="md-success"
                      >Enviar mensaje</md-button
                    >
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  bodyClass: "servicios-page",
  components: {},
  props: {
    header: {
      type: String,
      default: require("@/assets/img/conocenos.jpg")
    },
    teamImg1: {
      type: String,
      default: require("@/assets/img/icono-degradado.png")
    },
    teamImg2: {
      type: String,
      default: require("@/assets/img/faces/christian.jpg")
    },
    teamImg3: {
      type: String,
      default: require("@/assets/img/faces/kendall.jpg")
    }
  },
  data() {
    return {
      name: null,
      email: null,
      message: null,
      telefono: null,
      ciudad:null
    };
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`
      };
    }
  },
  methods: {
    sendEmail: function(e) {
      
      var data = this;
      var template_params = {
        reply_to: data.email,
        from_name: data.name,
        to_name: "Ingenieria y soluciones civiles",
        telefono: data.telefono,
        ciudad: data.ciudad,
        message_html: data.message
      };

      var service_id = "isc";
      var template_id = "template_f2p69cBy";
      emailjs.send(service_id, template_id, template_params).then(
        result => {
          data.name = null;
          data.email = null;
          data.message = null;
          alert("tu mensaje ha sido enviado");
        },
        error => {
          alert("No se pudo enviar tu mensaje, intenta de nuevo");
        }
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.md-card-actions.text-center {
  display: flex;
  justify-content: center !important;
}
.contact-form {
  margin-top: 30px;
}

.md-has-textarea + .md-layout {
  margin-top: 15px;
}
</style>
